import React, { useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';

const SignatureField = ({
    fieldName, // e.g., "responsiblePersonSignature"
    label = "", // Optional label override
    formData,
    isEditing,
    isDisabled,
    signatures,
    canvasRefs,
    invalidFields,
    updateSignatureData,
    clearSignature,
    toggleEditMode,
    isNext
}) => {
    const localRef = canvasRefs[fieldName];

    useEffect(() => {
        const canvasEl = localRef?.current?.getCanvas?.();
        if (!canvasEl) return;

        // Prevent touch gestures from scrolling or zooming the page
        const preventTouch = (e) => e.preventDefault();

        canvasEl.addEventListener("touchstart", preventTouch, { passive: false });
        canvasEl.addEventListener("touchmove", preventTouch, { passive: false });

        return () => {
            canvasEl.removeEventListener("touchstart", preventTouch);
            canvasEl.removeEventListener("touchmove", preventTouch);
        };
    }, [localRef]);


    const hasError =
        invalidFields.includes(label) && !formData[fieldName];

    return (
        <div className="w-full mb-4">
            <label className="block text-base font-medium text-black mb-2">
                {label}
            </label>

            {formData[fieldName] && !isEditing[fieldName] ? (
                <img
                    src={signatures[fieldName]}
                    alt="Signature"
                    loading="eager"
                    className="w-full max-w-sm h-24 sm:h-32 rounded-md border border-gray-300 object-contain mx-auto"
                    style={{ display: 'block' }}
                />
            ) : (
                <SignatureCanvas
                    ref={localRef}
                    backgroundColor="white"
                    penColor="black"
                    canvasProps={{
                        width: 500,
                        height: 128,
                        className: `w-full max-w-sm h-32 sm:h-40 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 ${hasError ? 'border border-red-500' : 'border border-gray-300'}`,
                    }}
                    disabled={isDisabled}
                />
            )}

            {!isNext && (
                <div className="flex flex-col sm:flex-row sm:space-x-4 space-y-2 sm:space-y-0 mt-3 justify-start">
                    {!formData[fieldName] && (
                        <button
                            disabled={isDisabled}
                            type="button"
                            onClick={() => updateSignatureData(fieldName)}
                            className="px-6 py-2 bg-green-600 text-white rounded-lg shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500 flex items-center justify-center"
                        >
                            <i className="fas fa-save mr-2"></i>
                            Save
                        </button>
                    )}

                    <button
                        disabled={isDisabled}
                        type="button"
                        onClick={() => {
                            toggleEditMode(fieldName, true);
                            clearSignature(fieldName);
                        }}
                        className="px-6 py-2 bg-red-600 text-white rounded-lg shadow hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 flex items-center justify-center"
                    >
                        <i className="fas fa-eraser mr-2"></i>
                        Clear
                    </button>
                </div>
            )}
        </div>

    );
};

export default SignatureField;
